<!-- =========================================================================================
  File Name: ResourceCreate.vue
  Description: Resource Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="resourceCreatePermission" id="page-user">
		<vx-card>
			<resource-create-tab-account class="mt-4" />
		</vx-card>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import ResourceCreateTabAccount from "./ResourceCreateTabAccount.vue";

export default {
	components: {
		NotPermission,
		ResourceCreateTabAccount,
	},
	computed: {
		resourceCreatePermission() {
			return this.$store.getters.checkPermission("RESOURCES_C");
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user {
	height: 30%;
}
</style>
